/* eslint-disable max-len */
import { EuroOutlined } from '@ant-design/icons';
import { Divider, Typography } from 'antd';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LocationState } from '../../../@types';

const { Title, Text, Paragraph } = Typography;

type Props = {
  children: React.ReactNode;
};

const CurrencyCard = (
  { children }: Props
) => {
  const location = useLocation<LocationState>();
  const isScreen = location.pathname === '/currency';
  const { t } = useTranslation();
  return (
    <AnimatePresence>
      <motion.div
        transition={{
          ease: 'easeInOut',
          duration: 1,
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Title
          style={{
            marginTop: isScreen ? 48 : 0, marginBottom: isScreen ? 24 : 12
          }}
          level={2}
        >
          <EuroOutlined />
          {' '}
          {t('currencyCard.title')}
        </Title>
        <Text>{t('currencyCard.desc1')}</Text>
        <StyledParagraph
          type="secondary"
          style={{
            fontStyle: 'italic', marginTop: 12
          }}
        >
          {t('currencyCard.desc2')}
        </StyledParagraph>
        <Divider />
        {children}
      </motion.div>
    </AnimatePresence>
  );
};


export default CurrencyCard;


const StyledParagraph = styled(Paragraph)`
  font-style: italic;
  margin-top: 12px;
`;